"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _uxUtils = require("@site/ux-utils");
var _reactMintl = require("@godaddy/react-mintl");
var _TickerTape = require("./styles/TickerTape");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TickerItemBody = ({
  items,
  prefix,
  isMobile
}) => {
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, items.map(item => /*#__PURE__*/_react.default.createElement(_TickerTape.TickerItem, {
    "data-cy": "ticker-item",
    "data-testid": "ticker-item",
    key: `ticker-item-${prefix}-${item?.text}`,
    isMobile: isMobile
  }, item.icon && /*#__PURE__*/_react.default.createElement(_TickerTape.TickerIcon, null, (0, _uxUtils.getIcon)({
    icon: item.icon,
    iconSize: isMobile ? 18 : 24
  })), /*#__PURE__*/_react.default.createElement(_TickerTape.TickerText, {
    bold: item.bold
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: item.text
  })))));
};
TickerItemBody.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    icon: _propTypes.default.string,
    bold: _propTypes.default.bool
  })),
  prefix: _propTypes.default.string,
  isMobile: _propTypes.default.bool
};
const TickerTape = ({
  items = [],
  direction = 'left',
  delay = 20
}) => {
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  return /*#__PURE__*/_react.default.createElement(_TickerTape.TickerContainer, {
    "data-cy": "ticker-container",
    "data-testid": "ticker-container",
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_TickerTape.TickerTrack, {
    direction: direction,
    delay: delay,
    "data-cy": "ticker-track",
    "data-testid": "ticker-track"
  }, /*#__PURE__*/_react.default.createElement(_TickerTape.TickerContent, null, /*#__PURE__*/_react.default.createElement(TickerItemBody, {
    items: items,
    prefix: "original",
    isMobile: isMobile
  })), /*#__PURE__*/_react.default.createElement(_TickerTape.TickerContent, null, /*#__PURE__*/_react.default.createElement(TickerItemBody, {
    items: items,
    prefix: "duplicate",
    isMobile: isMobile
  }))));
};
TickerTape.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    icon: _propTypes.default.string,
    bold: _propTypes.default.bool
  })),
  direction: _propTypes.default.string,
  delay: _propTypes.default.number
};
var _default = exports.default = TickerTape;